import { render } from "./TotalPerformance.vue?vue&type=template&id=13861b18&scoped=true"
import script from "./TotalPerformance.vue?vue&type=script&lang=js"
export * from "./TotalPerformance.vue?vue&type=script&lang=js"

import "./TotalPerformance.vue?vue&type=style&index=0&id=13861b18&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13861b18"]])

export default __exports__